import { Component, inject } from '@angular/core';

import { SideSectionService } from '../../services/side-section.service';
import { AUDIO_SETTINGS_SUB_MENU, MANAGE_PRESENTERS_SUB_MENU } from '../social-menu.types';

@Component({
  selector: 'app-presentation-settings',
  templateUrl: './presentation-settings.component.html',
  styleUrls: ['./presentation-settings.component.scss'],
  standalone: false,
})
export class PresentationSettingsComponent {
  private sideSectionService = inject(SideSectionService);

  public openAudioSettingsMenu(): void {
    this.sideSectionService.openSubMenu(AUDIO_SETTINGS_SUB_MENU);
  }

  public openManagePresentersMenu(): void {
    this.sideSectionService.openSubMenu(MANAGE_PRESENTERS_SUB_MENU);
  }
}
